(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atk-fuzzy-63-v2"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  if (!window.customElements || customElements.get('atk-fuzzy-product')) return;
  class AtkFuzzyProduct extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      const signal = this._abort.signal;
      this._buttons = Array.from(this.querySelectorAll('[data-atk-single-tab]'));
      this._panels = Array.from(this.querySelectorAll('[data-atk-single-panel]'));
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-atk-single-tab]');
        if (button && button.closest('atk-fuzzy-product') === this) this._activate(button.dataset.atkSingleTab);
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.ctrlKey || event.metaKey || event.altKey) return;
        const button = event.target.closest('[data-atk-single-tab]');
        if (!button || button.closest('atk-fuzzy-product') !== this) return;
        const index = this._buttons.indexOf(button);
        const count = this._buttons.length;
        if (!count) return;
        const rtl = getComputedStyle(this).direction === 'rtl';
        let target;
        if (event.key === 'ArrowRight') target = (index + (rtl ? count - 1 : 1)) % count;
        if (event.key === 'ArrowLeft') target = (index + (rtl ? 1 : count - 1)) % count;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = count - 1;
        if (target === undefined) return;
        event.preventDefault();
        const next = this._buttons[target];
        this._activate(next.dataset.atkSingleTab);
        next.focus({ preventScroll: true });
      }, { signal });
      document.addEventListener('shopify:block:select', event => {
        const scope = this.closest('.shopify-section') || this;
        if (!(event.target instanceof Node) || !scope.contains(event.target)) return;
        const blockId = event.detail && event.detail.blockId;
        const ownsBlock = Array.from(this.querySelectorAll('[data-atk-block]')).some(block => block.dataset.blockId === blockId || block === event.target || block.contains(event.target));
        if (ownsBlock) this._activate('description');
      }, { signal });
      this._activate('description');
    }
    disconnectedCallback() {
      this._abort?.abort();
      this._abort = null;
    }
    _activate(name) {
      if (!['description','information'].includes(name)) return;
      this._buttons.forEach(button => {
        const active = button.dataset.atkSingleTab === name;
        button.setAttribute('aria-selected',String(active));
        button.tabIndex = active ? 0 : -1;
      });
      this._panels.forEach(panel => { panel.hidden = panel.dataset.atkSinglePanel !== name; });
    }
  }
  customElements.define('atk-fuzzy-product', AtkFuzzyProduct);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["atk60-complete"] && !Shopify.designMode) return;
  try {
    
(() => {
  'use strict';
  const tagName = 'atk60s-product-details';
  if (!window.customElements || customElements.get(tagName)) return;

  class Atk60sProductDetails extends HTMLElement {
    connectedCallback() {
      if (this._abort) return;
      this._abort = new AbortController();
      this._active = 'description';
      const signal = this._abort.signal;
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-atk60s-tab]');
        if (button && button.closest(tagName) === this) this._activate(button.dataset.atk60sTab);
      }, { signal });
      this.addEventListener('keydown', event => this._onKey(event), { signal });
      document.addEventListener('DOMContentLoaded', () => this._refresh(), { signal, once: true });
      document.addEventListener('shopify:block:select', event => {
        const blockId = String(event.detail?.blockId || '');
        const ownTarget = event.target instanceof Element && this.contains(event.target);
        const ownBlock = blockId && Array.from(this.querySelectorAll('[data-atk60s-block]')).some(block => block.dataset.atk60sBlock === blockId);
        if (ownTarget || ownBlock) this._activate('description');
      }, { signal });
      this._refresh();
    }

    disconnectedCallback() {
      this._abort?.abort();
      this._abort = null;
      this._buttons = [];
      this._panels = [];
    }

    _refresh() {
      this._buttons = Array.from(this.querySelectorAll('[data-atk60s-tab]')).filter(node => node.closest(tagName) === this);
      this._panels = Array.from(this.querySelectorAll('[data-atk60s-panel]')).filter(node => node.closest(tagName) === this);
      this._activate(this._active);
    }

    _activate(name) {
      if (!['description', 'information'].includes(name)) return;
      this._active = name;
      this._buttons?.forEach(button => {
        const selected = button.dataset.atk60sTab === name;
        button.setAttribute('aria-selected', String(selected));
        button.tabIndex = selected ? 0 : -1;
      });
      this._panels?.forEach(panel => {
        panel.hidden = panel.dataset.atk60sPanel !== name;
      });
    }

    _onKey(event) {
      if (event.ctrlKey || event.metaKey || event.altKey) return;
      const button = event.target.closest('[data-atk60s-tab]');
      if (!button || button.closest(tagName) !== this) return;
      const index = this._buttons.indexOf(button);
      const count = this._buttons.length;
      const rtl = getComputedStyle(this).direction === 'rtl';
      let target;
      if (event.key === 'ArrowRight') target = (index + (rtl ? count - 1 : 1)) % count;
      if (event.key === 'ArrowLeft') target = (index + (rtl ? 1 : count - 1)) % count;
      if (event.key === 'Home') target = 0;
      if (event.key === 'End') target = count - 1;
      if (target === undefined) return;
      event.preventDefault();
      const next = this._buttons[target];
      this._activate(next.dataset.atk60sTab);
      next.focus({ preventScroll: true });
    }
  }

  customElements.define(tagName, Atk60sProductDetails);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuki-01-banner"] && !Shopify.designMode) return;
  try {
    
/* No theme globals, commerce handlers or third-party dependencies. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('yuki-showcase')) return;

  class YukiShowcase extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._generation = (this._generation || 0) + 1;
      this._cleanups = [];
      this._observers = [];
      this._frames = new Set();
      this._counted = new WeakSet();
      this._counterTargets = new Map();
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._reduceMotion = this._motionQuery.matches;
      this._on(this._motionQuery, 'change', () => {
        this._reduceMotion = this._motionQuery.matches;
        if (this._reduceMotion) this._revealAll();
        if (this._restartHero) this._restartHero();
        if (this._syncVideo) this._syncVideo();
      });
      this._setupReveals();
      this._setupHero();
      this._setupVideo();
      this._on(document, 'shopify:section:select', event => {
        if (this._ownsEditorEvent(event)) this._revealAll();
      });
    }

    disconnectedCallback() {
      this._connected = false;
      this._generation = (this._generation || 0) + 1;
      this._cleanups?.forEach(cleanup => cleanup());
      this._observers?.forEach(observer => observer.disconnect());
      this._frames?.forEach(frame => cancelAnimationFrame(frame));
      clearInterval(this._heroTimer);
      this._counterTargets?.forEach((target, node) => { node.textContent = String(target); });
      this.querySelectorAll('[data-reveal].is-pending').forEach(node => node.classList.remove('is-pending'));
      this.querySelectorAll('video').forEach(video => video.pause());
      this._restartHero = null;
      this._syncVideo = null;
    }

    _on(target, name, handler) {
      if (target.addEventListener) {
        target.addEventListener(name, handler);
        this._cleanups.push(() => target.removeEventListener(name, handler));
      } else if (name === 'change' && target.addListener) {
        target.addListener(handler);
        this._cleanups.push(() => target.removeListener(handler));
      }
    }

    _frame(callback) {
      const id = requestAnimationFrame(time => {
        this._frames.delete(id);
        if (this._connected) callback(time);
      });
      this._frames.add(id);
    }

    _observe(target, callback, options) {
      if (!('IntersectionObserver' in window)) return null;
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (this._connected && this._generation === generation) callback(entries);
      }, options);
      this._observers.push(observer);
      observer.observe(target);
      return observer;
    }

    _ownsEditorEvent(event) {
      const target = event.target;
      if (target instanceof Element && (target === this || this.contains(target) || target.contains(this))) return true;
      return Boolean(event.detail?.sectionId && this.id === `Yuki-${event.detail.sectionId}`);
    }

    _setupHero() {
      const hero = this.querySelector('.yuki-hero');
      if (!hero) return;
      const slides = [...hero.querySelectorAll('.yuki-hero-slide')];
      const dots = [...hero.querySelectorAll('.yuki-hero-dot')];
      const pauseButton = hero.querySelector('.yuki-hero-pause');
      if (!slides.length) return;
      let current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      let visible = true;
      let userPaused = false;
      let editorPaused = false;
      const automatic = this.dataset.autoplay !== 'false' && slides.length > 1;
      const rawInterval = Number(this.dataset.interval);
      const interval = Number.isFinite(rawInterval) && rawInterval >= 3000 ? Math.min(rawInterval, 30000) : 6000;

      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          slide.setAttribute('aria-hidden', String(i !== current));
          // A merchant can add a link to a slide without leaving hidden links focusable.
          if ('inert' in slide) slide.inert = i !== current;
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
        // Load the following frame before its crossfade begins.
        slides[(current + 1) % slides.length].querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
      };
      const restart = () => {
        clearInterval(this._heroTimer);
        if (pauseButton) {
          pauseButton.hidden = !automatic || this._reduceMotion;
          pauseButton.setAttribute('aria-pressed', String(userPaused));
          const label = userPaused ? (pauseButton.dataset.labelPlay || 'Play slideshow') : (pauseButton.dataset.labelPause || 'Pause slideshow');
          pauseButton.setAttribute('aria-label', label);
          pauseButton.textContent = userPaused ? '▶' : 'Ⅱ';
        }
        if (!this._connected || !automatic || this._reduceMotion || userPaused || editorPaused || !visible || document.hidden || hero.contains(document.activeElement)) return;
        this._heroTimer = setInterval(() => show(current + 1), interval);
      };
      this._restartHero = restart;
      dots.forEach((dot, i) => this._on(dot, 'click', () => {
        const index = Number(dot.dataset.slide);
        show(Number.isInteger(index) && index >= 0 && index < slides.length ? index : i);
        restart();
      }));
      if (pauseButton) this._on(pauseButton, 'click', () => { userPaused = !userPaused; restart(); });
      this._on(hero, 'focusin', restart);
      this._on(hero, 'focusout', () => this._frame(restart));
      this._on(document, 'visibilitychange', restart);
      this._on(document, 'shopify:section:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = true;
        restart();
      });
      this._on(document, 'shopify:section:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._on(document, 'shopify:block:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target) || (event.detail?.blockId && slide.dataset.blockId === String(event.detail.blockId)));
        if (index < 0) return;
        editorPaused = true;
        show(index);
        restart();
      });
      this._on(document, 'shopify:block:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._observe(hero, entries => { visible = entries[0].isIntersecting; restart(); });
      show(current);
      restart();
    }

    _setupVideo() {
      const video = this.querySelector('.yuki-video video');
      const playButton = this.querySelector('.yuki-video-play');
      if (!video) return;
      const automatic = this.dataset.autoplay !== 'false';
      const generation = this._generation;
      let visible = !('IntersectionObserver' in window);
      let manualPlayback = false;
      let playRequest = 0;
      video.autoplay = false;
      video.removeAttribute('autoplay');
      const offerPlay = () => { if (playButton) playButton.hidden = false; };
      const play = async () => {
        const request = ++playRequest;
        try {
          await video.play();
          if (!this._connected || this._generation !== generation || request !== playRequest) return;
          if (playButton) playButton.hidden = true;
        } catch {
          if (this._connected && this._generation === generation && request === playRequest) offerPlay();
        }
      };
      const sync = () => {
        const autoAllowed = automatic && !this._reduceMotion;
        video.controls = !autoAllowed || manualPlayback;
        if (document.hidden || !visible) {
          ++playRequest;
          video.pause();
          return;
        }
        if (autoAllowed && !manualPlayback) {
          video.muted = true;
          void play();
        } else {
          if (!manualPlayback) video.pause();
          if (video.paused) offerPlay();
        }
      };
      this._syncVideo = sync;
      if (playButton) this._on(playButton, 'click', () => {
        manualPlayback = true;
        video.controls = true;
        void play();
      });
      this._on(video, 'play', () => {
        if (video.controls) manualPlayback = true;
        if (playButton) playButton.hidden = true;
      });
      this._on(video, 'pause', () => { if (video.controls && visible) offerPlay(); });
      this._on(video, 'ended', offerPlay);
      this._on(video, 'error', offerPlay);
      this._on(document, 'visibilitychange', sync);
      this._observe(video, entries => { visible = entries[0].isIntersecting; sync(); });
      sync();
    }

    _setupReveals() {
      const nodes = [...this.querySelectorAll('[data-reveal]')];
      if (!nodes.length) return;
      if (this._reduceMotion || !('IntersectionObserver' in window)) {
        this._revealAll();
        return;
      }
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (!this._connected || this._generation !== generation) return;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this._reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -100px 0px' });
      this._observers.push(observer);
      nodes.forEach(node => {
        if (node.classList.contains('is-revealed')) return;
        node.classList.add('is-pending');
        observer.observe(node);
      });
    }

    _reveal(node) {
      node.classList.add('is-revealed');
      node.classList.remove('is-pending');
      const counters = [...node.querySelectorAll('.yuki-counter, [data-counter-target]')];
      if (node.matches('.yuki-counter, [data-counter-target]')) counters.push(node);
      counters.forEach(counter => this._countUp(counter));
    }

    _revealAll() {
      this.querySelectorAll('[data-reveal]').forEach(node => this._reveal(node));
      if (this._reduceMotion) this._counterTargets.forEach((target, node) => { node.textContent = String(target); });
    }

    _countUp(number) {
      if (this._counted.has(number)) return;
      this._counted.add(number);
      const rawTarget = Number(number.dataset.counterTarget ?? number.textContent.trim());
      const target = Number.isFinite(rawTarget) ? Math.max(0, Math.min(100000, Math.round(rawTarget))) : 3;
      this._counterTargets.set(number, target);
      if (this._reduceMotion) { number.textContent = String(target); return; }
      const start = performance.now();
      const tick = now => {
        if (this._reduceMotion) { number.textContent = String(target); return; }
        const progress = Math.min((now - start) / 2000, 1);
        number.textContent = String(Math.floor(target * (1 - Math.pow(1 - progress, 3)) + .000001));
        if (progress < 1) this._frame(tick);
        else number.textContent = String(target);
      };
      this._frame(tick);
    }
  }

  customElements.define('yuki-showcase', YukiShowcase);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuki-02-video"] && !Shopify.designMode) return;
  try {
    
/* No theme globals, commerce handlers or third-party dependencies. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('yuki-showcase')) return;

  class YukiShowcase extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._generation = (this._generation || 0) + 1;
      this._cleanups = [];
      this._observers = [];
      this._frames = new Set();
      this._counted = new WeakSet();
      this._counterTargets = new Map();
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._reduceMotion = this._motionQuery.matches;
      this._on(this._motionQuery, 'change', () => {
        this._reduceMotion = this._motionQuery.matches;
        if (this._reduceMotion) this._revealAll();
        if (this._restartHero) this._restartHero();
        if (this._syncVideo) this._syncVideo();
      });
      this._setupReveals();
      this._setupHero();
      this._setupVideo();
      this._on(document, 'shopify:section:select', event => {
        if (this._ownsEditorEvent(event)) this._revealAll();
      });
    }

    disconnectedCallback() {
      this._connected = false;
      this._generation = (this._generation || 0) + 1;
      this._cleanups?.forEach(cleanup => cleanup());
      this._observers?.forEach(observer => observer.disconnect());
      this._frames?.forEach(frame => cancelAnimationFrame(frame));
      clearInterval(this._heroTimer);
      this._counterTargets?.forEach((target, node) => { node.textContent = String(target); });
      this.querySelectorAll('[data-reveal].is-pending').forEach(node => node.classList.remove('is-pending'));
      this.querySelectorAll('video').forEach(video => video.pause());
      this._restartHero = null;
      this._syncVideo = null;
    }

    _on(target, name, handler) {
      if (target.addEventListener) {
        target.addEventListener(name, handler);
        this._cleanups.push(() => target.removeEventListener(name, handler));
      } else if (name === 'change' && target.addListener) {
        target.addListener(handler);
        this._cleanups.push(() => target.removeListener(handler));
      }
    }

    _frame(callback) {
      const id = requestAnimationFrame(time => {
        this._frames.delete(id);
        if (this._connected) callback(time);
      });
      this._frames.add(id);
    }

    _observe(target, callback, options) {
      if (!('IntersectionObserver' in window)) return null;
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (this._connected && this._generation === generation) callback(entries);
      }, options);
      this._observers.push(observer);
      observer.observe(target);
      return observer;
    }

    _ownsEditorEvent(event) {
      const target = event.target;
      if (target instanceof Element && (target === this || this.contains(target) || target.contains(this))) return true;
      return Boolean(event.detail?.sectionId && this.id === `Yuki-${event.detail.sectionId}`);
    }

    _setupHero() {
      const hero = this.querySelector('.yuki-hero');
      if (!hero) return;
      const slides = [...hero.querySelectorAll('.yuki-hero-slide')];
      const dots = [...hero.querySelectorAll('.yuki-hero-dot')];
      const pauseButton = hero.querySelector('.yuki-hero-pause');
      if (!slides.length) return;
      let current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      let visible = true;
      let userPaused = false;
      let editorPaused = false;
      const automatic = this.dataset.autoplay !== 'false' && slides.length > 1;
      const rawInterval = Number(this.dataset.interval);
      const interval = Number.isFinite(rawInterval) && rawInterval >= 3000 ? Math.min(rawInterval, 30000) : 6000;

      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          slide.setAttribute('aria-hidden', String(i !== current));
          // A merchant can add a link to a slide without leaving hidden links focusable.
          if ('inert' in slide) slide.inert = i !== current;
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
        // Load the following frame before its crossfade begins.
        slides[(current + 1) % slides.length].querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
      };
      const restart = () => {
        clearInterval(this._heroTimer);
        if (pauseButton) {
          pauseButton.hidden = !automatic || this._reduceMotion;
          pauseButton.setAttribute('aria-pressed', String(userPaused));
          const label = userPaused ? (pauseButton.dataset.labelPlay || 'Play slideshow') : (pauseButton.dataset.labelPause || 'Pause slideshow');
          pauseButton.setAttribute('aria-label', label);
          pauseButton.textContent = userPaused ? '▶' : 'Ⅱ';
        }
        if (!this._connected || !automatic || this._reduceMotion || userPaused || editorPaused || !visible || document.hidden || hero.contains(document.activeElement)) return;
        this._heroTimer = setInterval(() => show(current + 1), interval);
      };
      this._restartHero = restart;
      dots.forEach((dot, i) => this._on(dot, 'click', () => {
        const index = Number(dot.dataset.slide);
        show(Number.isInteger(index) && index >= 0 && index < slides.length ? index : i);
        restart();
      }));
      if (pauseButton) this._on(pauseButton, 'click', () => { userPaused = !userPaused; restart(); });
      this._on(hero, 'focusin', restart);
      this._on(hero, 'focusout', () => this._frame(restart));
      this._on(document, 'visibilitychange', restart);
      this._on(document, 'shopify:section:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = true;
        restart();
      });
      this._on(document, 'shopify:section:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._on(document, 'shopify:block:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target) || (event.detail?.blockId && slide.dataset.blockId === String(event.detail.blockId)));
        if (index < 0) return;
        editorPaused = true;
        show(index);
        restart();
      });
      this._on(document, 'shopify:block:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._observe(hero, entries => { visible = entries[0].isIntersecting; restart(); });
      show(current);
      restart();
    }

    _setupVideo() {
      const video = this.querySelector('.yuki-video video');
      const playButton = this.querySelector('.yuki-video-play');
      if (!video) return;
      const automatic = this.dataset.autoplay !== 'false';
      const generation = this._generation;
      let visible = !('IntersectionObserver' in window);
      let manualPlayback = false;
      let playRequest = 0;
      video.autoplay = false;
      video.removeAttribute('autoplay');
      const offerPlay = () => { if (playButton) playButton.hidden = false; };
      const play = async () => {
        const request = ++playRequest;
        try {
          await video.play();
          if (!this._connected || this._generation !== generation || request !== playRequest) return;
          if (playButton) playButton.hidden = true;
        } catch {
          if (this._connected && this._generation === generation && request === playRequest) offerPlay();
        }
      };
      const sync = () => {
        const autoAllowed = automatic && !this._reduceMotion;
        video.controls = !autoAllowed || manualPlayback;
        if (document.hidden || !visible) {
          ++playRequest;
          video.pause();
          return;
        }
        if (autoAllowed && !manualPlayback) {
          video.muted = true;
          void play();
        } else {
          if (!manualPlayback) video.pause();
          if (video.paused) offerPlay();
        }
      };
      this._syncVideo = sync;
      if (playButton) this._on(playButton, 'click', () => {
        manualPlayback = true;
        video.controls = true;
        void play();
      });
      this._on(video, 'play', () => {
        if (video.controls) manualPlayback = true;
        if (playButton) playButton.hidden = true;
      });
      this._on(video, 'pause', () => { if (video.controls && visible) offerPlay(); });
      this._on(video, 'ended', offerPlay);
      this._on(video, 'error', offerPlay);
      this._on(document, 'visibilitychange', sync);
      this._observe(video, entries => { visible = entries[0].isIntersecting; sync(); });
      sync();
    }

    _setupReveals() {
      const nodes = [...this.querySelectorAll('[data-reveal]')];
      if (!nodes.length) return;
      if (this._reduceMotion || !('IntersectionObserver' in window)) {
        this._revealAll();
        return;
      }
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (!this._connected || this._generation !== generation) return;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this._reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -100px 0px' });
      this._observers.push(observer);
      nodes.forEach(node => {
        if (node.classList.contains('is-revealed')) return;
        node.classList.add('is-pending');
        observer.observe(node);
      });
    }

    _reveal(node) {
      node.classList.add('is-revealed');
      node.classList.remove('is-pending');
      const counters = [...node.querySelectorAll('.yuki-counter, [data-counter-target]')];
      if (node.matches('.yuki-counter, [data-counter-target]')) counters.push(node);
      counters.forEach(counter => this._countUp(counter));
    }

    _revealAll() {
      this.querySelectorAll('[data-reveal]').forEach(node => this._reveal(node));
      if (this._reduceMotion) this._counterTargets.forEach((target, node) => { node.textContent = String(target); });
    }

    _countUp(number) {
      if (this._counted.has(number)) return;
      this._counted.add(number);
      const rawTarget = Number(number.dataset.counterTarget ?? number.textContent.trim());
      const target = Number.isFinite(rawTarget) ? Math.max(0, Math.min(100000, Math.round(rawTarget))) : 3;
      this._counterTargets.set(number, target);
      if (this._reduceMotion) { number.textContent = String(target); return; }
      const start = performance.now();
      const tick = now => {
        if (this._reduceMotion) { number.textContent = String(target); return; }
        const progress = Math.min((now - start) / 2000, 1);
        number.textContent = String(Math.floor(target * (1 - Math.pow(1 - progress, 3)) + .000001));
        if (progress < 1) this._frame(tick);
        else number.textContent = String(target);
      };
      this._frame(tick);
    }
  }

  customElements.define('yuki-showcase', YukiShowcase);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuki-03-intro"] && !Shopify.designMode) return;
  try {
    
/* No theme globals, commerce handlers or third-party dependencies. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('yuki-showcase')) return;

  class YukiShowcase extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._generation = (this._generation || 0) + 1;
      this._cleanups = [];
      this._observers = [];
      this._frames = new Set();
      this._counted = new WeakSet();
      this._counterTargets = new Map();
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._reduceMotion = this._motionQuery.matches;
      this._on(this._motionQuery, 'change', () => {
        this._reduceMotion = this._motionQuery.matches;
        if (this._reduceMotion) this._revealAll();
        if (this._restartHero) this._restartHero();
        if (this._syncVideo) this._syncVideo();
      });
      this._setupReveals();
      this._setupHero();
      this._setupVideo();
      this._on(document, 'shopify:section:select', event => {
        if (this._ownsEditorEvent(event)) this._revealAll();
      });
    }

    disconnectedCallback() {
      this._connected = false;
      this._generation = (this._generation || 0) + 1;
      this._cleanups?.forEach(cleanup => cleanup());
      this._observers?.forEach(observer => observer.disconnect());
      this._frames?.forEach(frame => cancelAnimationFrame(frame));
      clearInterval(this._heroTimer);
      this._counterTargets?.forEach((target, node) => { node.textContent = String(target); });
      this.querySelectorAll('[data-reveal].is-pending').forEach(node => node.classList.remove('is-pending'));
      this.querySelectorAll('video').forEach(video => video.pause());
      this._restartHero = null;
      this._syncVideo = null;
    }

    _on(target, name, handler) {
      if (target.addEventListener) {
        target.addEventListener(name, handler);
        this._cleanups.push(() => target.removeEventListener(name, handler));
      } else if (name === 'change' && target.addListener) {
        target.addListener(handler);
        this._cleanups.push(() => target.removeListener(handler));
      }
    }

    _frame(callback) {
      const id = requestAnimationFrame(time => {
        this._frames.delete(id);
        if (this._connected) callback(time);
      });
      this._frames.add(id);
    }

    _observe(target, callback, options) {
      if (!('IntersectionObserver' in window)) return null;
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (this._connected && this._generation === generation) callback(entries);
      }, options);
      this._observers.push(observer);
      observer.observe(target);
      return observer;
    }

    _ownsEditorEvent(event) {
      const target = event.target;
      if (target instanceof Element && (target === this || this.contains(target) || target.contains(this))) return true;
      return Boolean(event.detail?.sectionId && this.id === `Yuki-${event.detail.sectionId}`);
    }

    _setupHero() {
      const hero = this.querySelector('.yuki-hero');
      if (!hero) return;
      const slides = [...hero.querySelectorAll('.yuki-hero-slide')];
      const dots = [...hero.querySelectorAll('.yuki-hero-dot')];
      const pauseButton = hero.querySelector('.yuki-hero-pause');
      if (!slides.length) return;
      let current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      let visible = true;
      let userPaused = false;
      let editorPaused = false;
      const automatic = this.dataset.autoplay !== 'false' && slides.length > 1;
      const rawInterval = Number(this.dataset.interval);
      const interval = Number.isFinite(rawInterval) && rawInterval >= 3000 ? Math.min(rawInterval, 30000) : 6000;

      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          slide.setAttribute('aria-hidden', String(i !== current));
          // A merchant can add a link to a slide without leaving hidden links focusable.
          if ('inert' in slide) slide.inert = i !== current;
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
        // Load the following frame before its crossfade begins.
        slides[(current + 1) % slides.length].querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
      };
      const restart = () => {
        clearInterval(this._heroTimer);
        if (pauseButton) {
          pauseButton.hidden = !automatic || this._reduceMotion;
          pauseButton.setAttribute('aria-pressed', String(userPaused));
          const label = userPaused ? (pauseButton.dataset.labelPlay || 'Play slideshow') : (pauseButton.dataset.labelPause || 'Pause slideshow');
          pauseButton.setAttribute('aria-label', label);
          pauseButton.textContent = userPaused ? '▶' : 'Ⅱ';
        }
        if (!this._connected || !automatic || this._reduceMotion || userPaused || editorPaused || !visible || document.hidden || hero.contains(document.activeElement)) return;
        this._heroTimer = setInterval(() => show(current + 1), interval);
      };
      this._restartHero = restart;
      dots.forEach((dot, i) => this._on(dot, 'click', () => {
        const index = Number(dot.dataset.slide);
        show(Number.isInteger(index) && index >= 0 && index < slides.length ? index : i);
        restart();
      }));
      if (pauseButton) this._on(pauseButton, 'click', () => { userPaused = !userPaused; restart(); });
      this._on(hero, 'focusin', restart);
      this._on(hero, 'focusout', () => this._frame(restart));
      this._on(document, 'visibilitychange', restart);
      this._on(document, 'shopify:section:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = true;
        restart();
      });
      this._on(document, 'shopify:section:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._on(document, 'shopify:block:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target) || (event.detail?.blockId && slide.dataset.blockId === String(event.detail.blockId)));
        if (index < 0) return;
        editorPaused = true;
        show(index);
        restart();
      });
      this._on(document, 'shopify:block:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._observe(hero, entries => { visible = entries[0].isIntersecting; restart(); });
      show(current);
      restart();
    }

    _setupVideo() {
      const video = this.querySelector('.yuki-video video');
      const playButton = this.querySelector('.yuki-video-play');
      if (!video) return;
      const automatic = this.dataset.autoplay !== 'false';
      const generation = this._generation;
      let visible = !('IntersectionObserver' in window);
      let manualPlayback = false;
      let playRequest = 0;
      video.autoplay = false;
      video.removeAttribute('autoplay');
      const offerPlay = () => { if (playButton) playButton.hidden = false; };
      const play = async () => {
        const request = ++playRequest;
        try {
          await video.play();
          if (!this._connected || this._generation !== generation || request !== playRequest) return;
          if (playButton) playButton.hidden = true;
        } catch {
          if (this._connected && this._generation === generation && request === playRequest) offerPlay();
        }
      };
      const sync = () => {
        const autoAllowed = automatic && !this._reduceMotion;
        video.controls = !autoAllowed || manualPlayback;
        if (document.hidden || !visible) {
          ++playRequest;
          video.pause();
          return;
        }
        if (autoAllowed && !manualPlayback) {
          video.muted = true;
          void play();
        } else {
          if (!manualPlayback) video.pause();
          if (video.paused) offerPlay();
        }
      };
      this._syncVideo = sync;
      if (playButton) this._on(playButton, 'click', () => {
        manualPlayback = true;
        video.controls = true;
        void play();
      });
      this._on(video, 'play', () => {
        if (video.controls) manualPlayback = true;
        if (playButton) playButton.hidden = true;
      });
      this._on(video, 'pause', () => { if (video.controls && visible) offerPlay(); });
      this._on(video, 'ended', offerPlay);
      this._on(video, 'error', offerPlay);
      this._on(document, 'visibilitychange', sync);
      this._observe(video, entries => { visible = entries[0].isIntersecting; sync(); });
      sync();
    }

    _setupReveals() {
      const nodes = [...this.querySelectorAll('[data-reveal]')];
      if (!nodes.length) return;
      if (this._reduceMotion || !('IntersectionObserver' in window)) {
        this._revealAll();
        return;
      }
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (!this._connected || this._generation !== generation) return;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this._reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -100px 0px' });
      this._observers.push(observer);
      nodes.forEach(node => {
        if (node.classList.contains('is-revealed')) return;
        node.classList.add('is-pending');
        observer.observe(node);
      });
    }

    _reveal(node) {
      node.classList.add('is-revealed');
      node.classList.remove('is-pending');
      const counters = [...node.querySelectorAll('.yuki-counter, [data-counter-target]')];
      if (node.matches('.yuki-counter, [data-counter-target]')) counters.push(node);
      counters.forEach(counter => this._countUp(counter));
    }

    _revealAll() {
      this.querySelectorAll('[data-reveal]').forEach(node => this._reveal(node));
      if (this._reduceMotion) this._counterTargets.forEach((target, node) => { node.textContent = String(target); });
    }

    _countUp(number) {
      if (this._counted.has(number)) return;
      this._counted.add(number);
      const rawTarget = Number(number.dataset.counterTarget ?? number.textContent.trim());
      const target = Number.isFinite(rawTarget) ? Math.max(0, Math.min(100000, Math.round(rawTarget))) : 3;
      this._counterTargets.set(number, target);
      if (this._reduceMotion) { number.textContent = String(target); return; }
      const start = performance.now();
      const tick = now => {
        if (this._reduceMotion) { number.textContent = String(target); return; }
        const progress = Math.min((now - start) / 2000, 1);
        number.textContent = String(Math.floor(target * (1 - Math.pow(1 - progress, 3)) + .000001));
        if (progress < 1) this._frame(tick);
        else number.textContent = String(target);
      };
      this._frame(tick);
    }
  }

  customElements.define('yuki-showcase', YukiShowcase);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuki-04-image-grid"] && !Shopify.designMode) return;
  try {
    
/* No theme globals, commerce handlers or third-party dependencies. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('yuki-showcase')) return;

  class YukiShowcase extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._generation = (this._generation || 0) + 1;
      this._cleanups = [];
      this._observers = [];
      this._frames = new Set();
      this._counted = new WeakSet();
      this._counterTargets = new Map();
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._reduceMotion = this._motionQuery.matches;
      this._on(this._motionQuery, 'change', () => {
        this._reduceMotion = this._motionQuery.matches;
        if (this._reduceMotion) this._revealAll();
        if (this._restartHero) this._restartHero();
        if (this._syncVideo) this._syncVideo();
      });
      this._setupReveals();
      this._setupHero();
      this._setupVideo();
      this._on(document, 'shopify:section:select', event => {
        if (this._ownsEditorEvent(event)) this._revealAll();
      });
    }

    disconnectedCallback() {
      this._connected = false;
      this._generation = (this._generation || 0) + 1;
      this._cleanups?.forEach(cleanup => cleanup());
      this._observers?.forEach(observer => observer.disconnect());
      this._frames?.forEach(frame => cancelAnimationFrame(frame));
      clearInterval(this._heroTimer);
      this._counterTargets?.forEach((target, node) => { node.textContent = String(target); });
      this.querySelectorAll('[data-reveal].is-pending').forEach(node => node.classList.remove('is-pending'));
      this.querySelectorAll('video').forEach(video => video.pause());
      this._restartHero = null;
      this._syncVideo = null;
    }

    _on(target, name, handler) {
      if (target.addEventListener) {
        target.addEventListener(name, handler);
        this._cleanups.push(() => target.removeEventListener(name, handler));
      } else if (name === 'change' && target.addListener) {
        target.addListener(handler);
        this._cleanups.push(() => target.removeListener(handler));
      }
    }

    _frame(callback) {
      const id = requestAnimationFrame(time => {
        this._frames.delete(id);
        if (this._connected) callback(time);
      });
      this._frames.add(id);
    }

    _observe(target, callback, options) {
      if (!('IntersectionObserver' in window)) return null;
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (this._connected && this._generation === generation) callback(entries);
      }, options);
      this._observers.push(observer);
      observer.observe(target);
      return observer;
    }

    _ownsEditorEvent(event) {
      const target = event.target;
      if (target instanceof Element && (target === this || this.contains(target) || target.contains(this))) return true;
      return Boolean(event.detail?.sectionId && this.id === `Yuki-${event.detail.sectionId}`);
    }

    _setupHero() {
      const hero = this.querySelector('.yuki-hero');
      if (!hero) return;
      const slides = [...hero.querySelectorAll('.yuki-hero-slide')];
      const dots = [...hero.querySelectorAll('.yuki-hero-dot')];
      const pauseButton = hero.querySelector('.yuki-hero-pause');
      if (!slides.length) return;
      let current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      let visible = true;
      let userPaused = false;
      let editorPaused = false;
      const automatic = this.dataset.autoplay !== 'false' && slides.length > 1;
      const rawInterval = Number(this.dataset.interval);
      const interval = Number.isFinite(rawInterval) && rawInterval >= 3000 ? Math.min(rawInterval, 30000) : 6000;

      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          slide.setAttribute('aria-hidden', String(i !== current));
          // A merchant can add a link to a slide without leaving hidden links focusable.
          if ('inert' in slide) slide.inert = i !== current;
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
        // Load the following frame before its crossfade begins.
        slides[(current + 1) % slides.length].querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
      };
      const restart = () => {
        clearInterval(this._heroTimer);
        if (pauseButton) {
          pauseButton.hidden = !automatic || this._reduceMotion;
          pauseButton.setAttribute('aria-pressed', String(userPaused));
          const label = userPaused ? (pauseButton.dataset.labelPlay || 'Play slideshow') : (pauseButton.dataset.labelPause || 'Pause slideshow');
          pauseButton.setAttribute('aria-label', label);
          pauseButton.textContent = userPaused ? '▶' : 'Ⅱ';
        }
        if (!this._connected || !automatic || this._reduceMotion || userPaused || editorPaused || !visible || document.hidden || hero.contains(document.activeElement)) return;
        this._heroTimer = setInterval(() => show(current + 1), interval);
      };
      this._restartHero = restart;
      dots.forEach((dot, i) => this._on(dot, 'click', () => {
        const index = Number(dot.dataset.slide);
        show(Number.isInteger(index) && index >= 0 && index < slides.length ? index : i);
        restart();
      }));
      if (pauseButton) this._on(pauseButton, 'click', () => { userPaused = !userPaused; restart(); });
      this._on(hero, 'focusin', restart);
      this._on(hero, 'focusout', () => this._frame(restart));
      this._on(document, 'visibilitychange', restart);
      this._on(document, 'shopify:section:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = true;
        restart();
      });
      this._on(document, 'shopify:section:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._on(document, 'shopify:block:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target) || (event.detail?.blockId && slide.dataset.blockId === String(event.detail.blockId)));
        if (index < 0) return;
        editorPaused = true;
        show(index);
        restart();
      });
      this._on(document, 'shopify:block:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._observe(hero, entries => { visible = entries[0].isIntersecting; restart(); });
      show(current);
      restart();
    }

    _setupVideo() {
      const video = this.querySelector('.yuki-video video');
      const playButton = this.querySelector('.yuki-video-play');
      if (!video) return;
      const automatic = this.dataset.autoplay !== 'false';
      const generation = this._generation;
      let visible = !('IntersectionObserver' in window);
      let manualPlayback = false;
      let playRequest = 0;
      video.autoplay = false;
      video.removeAttribute('autoplay');
      const offerPlay = () => { if (playButton) playButton.hidden = false; };
      const play = async () => {
        const request = ++playRequest;
        try {
          await video.play();
          if (!this._connected || this._generation !== generation || request !== playRequest) return;
          if (playButton) playButton.hidden = true;
        } catch {
          if (this._connected && this._generation === generation && request === playRequest) offerPlay();
        }
      };
      const sync = () => {
        const autoAllowed = automatic && !this._reduceMotion;
        video.controls = !autoAllowed || manualPlayback;
        if (document.hidden || !visible) {
          ++playRequest;
          video.pause();
          return;
        }
        if (autoAllowed && !manualPlayback) {
          video.muted = true;
          void play();
        } else {
          if (!manualPlayback) video.pause();
          if (video.paused) offerPlay();
        }
      };
      this._syncVideo = sync;
      if (playButton) this._on(playButton, 'click', () => {
        manualPlayback = true;
        video.controls = true;
        void play();
      });
      this._on(video, 'play', () => {
        if (video.controls) manualPlayback = true;
        if (playButton) playButton.hidden = true;
      });
      this._on(video, 'pause', () => { if (video.controls && visible) offerPlay(); });
      this._on(video, 'ended', offerPlay);
      this._on(video, 'error', offerPlay);
      this._on(document, 'visibilitychange', sync);
      this._observe(video, entries => { visible = entries[0].isIntersecting; sync(); });
      sync();
    }

    _setupReveals() {
      const nodes = [...this.querySelectorAll('[data-reveal]')];
      if (!nodes.length) return;
      if (this._reduceMotion || !('IntersectionObserver' in window)) {
        this._revealAll();
        return;
      }
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (!this._connected || this._generation !== generation) return;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this._reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -100px 0px' });
      this._observers.push(observer);
      nodes.forEach(node => {
        if (node.classList.contains('is-revealed')) return;
        node.classList.add('is-pending');
        observer.observe(node);
      });
    }

    _reveal(node) {
      node.classList.add('is-revealed');
      node.classList.remove('is-pending');
      const counters = [...node.querySelectorAll('.yuki-counter, [data-counter-target]')];
      if (node.matches('.yuki-counter, [data-counter-target]')) counters.push(node);
      counters.forEach(counter => this._countUp(counter));
    }

    _revealAll() {
      this.querySelectorAll('[data-reveal]').forEach(node => this._reveal(node));
      if (this._reduceMotion) this._counterTargets.forEach((target, node) => { node.textContent = String(target); });
    }

    _countUp(number) {
      if (this._counted.has(number)) return;
      this._counted.add(number);
      const rawTarget = Number(number.dataset.counterTarget ?? number.textContent.trim());
      const target = Number.isFinite(rawTarget) ? Math.max(0, Math.min(100000, Math.round(rawTarget))) : 3;
      this._counterTargets.set(number, target);
      if (this._reduceMotion) { number.textContent = String(target); return; }
      const start = performance.now();
      const tick = now => {
        if (this._reduceMotion) { number.textContent = String(target); return; }
        const progress = Math.min((now - start) / 2000, 1);
        number.textContent = String(Math.floor(target * (1 - Math.pow(1 - progress, 3)) + .000001));
        if (progress < 1) this._frame(tick);
        else number.textContent = String(target);
      };
      this._frame(tick);
    }
  }

  customElements.define('yuki-showcase', YukiShowcase);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuki-05-features"] && !Shopify.designMode) return;
  try {
    
/* No theme globals, commerce handlers or third-party dependencies. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('yuki-showcase')) return;

  class YukiShowcase extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._generation = (this._generation || 0) + 1;
      this._cleanups = [];
      this._observers = [];
      this._frames = new Set();
      this._counted = new WeakSet();
      this._counterTargets = new Map();
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._reduceMotion = this._motionQuery.matches;
      this._on(this._motionQuery, 'change', () => {
        this._reduceMotion = this._motionQuery.matches;
        if (this._reduceMotion) this._revealAll();
        if (this._restartHero) this._restartHero();
        if (this._syncVideo) this._syncVideo();
      });
      this._setupReveals();
      this._setupHero();
      this._setupVideo();
      this._on(document, 'shopify:section:select', event => {
        if (this._ownsEditorEvent(event)) this._revealAll();
      });
    }

    disconnectedCallback() {
      this._connected = false;
      this._generation = (this._generation || 0) + 1;
      this._cleanups?.forEach(cleanup => cleanup());
      this._observers?.forEach(observer => observer.disconnect());
      this._frames?.forEach(frame => cancelAnimationFrame(frame));
      clearInterval(this._heroTimer);
      this._counterTargets?.forEach((target, node) => { node.textContent = String(target); });
      this.querySelectorAll('[data-reveal].is-pending').forEach(node => node.classList.remove('is-pending'));
      this.querySelectorAll('video').forEach(video => video.pause());
      this._restartHero = null;
      this._syncVideo = null;
    }

    _on(target, name, handler) {
      if (target.addEventListener) {
        target.addEventListener(name, handler);
        this._cleanups.push(() => target.removeEventListener(name, handler));
      } else if (name === 'change' && target.addListener) {
        target.addListener(handler);
        this._cleanups.push(() => target.removeListener(handler));
      }
    }

    _frame(callback) {
      const id = requestAnimationFrame(time => {
        this._frames.delete(id);
        if (this._connected) callback(time);
      });
      this._frames.add(id);
    }

    _observe(target, callback, options) {
      if (!('IntersectionObserver' in window)) return null;
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (this._connected && this._generation === generation) callback(entries);
      }, options);
      this._observers.push(observer);
      observer.observe(target);
      return observer;
    }

    _ownsEditorEvent(event) {
      const target = event.target;
      if (target instanceof Element && (target === this || this.contains(target) || target.contains(this))) return true;
      return Boolean(event.detail?.sectionId && this.id === `Yuki-${event.detail.sectionId}`);
    }

    _setupHero() {
      const hero = this.querySelector('.yuki-hero');
      if (!hero) return;
      const slides = [...hero.querySelectorAll('.yuki-hero-slide')];
      const dots = [...hero.querySelectorAll('.yuki-hero-dot')];
      const pauseButton = hero.querySelector('.yuki-hero-pause');
      if (!slides.length) return;
      let current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      let visible = true;
      let userPaused = false;
      let editorPaused = false;
      const automatic = this.dataset.autoplay !== 'false' && slides.length > 1;
      const rawInterval = Number(this.dataset.interval);
      const interval = Number.isFinite(rawInterval) && rawInterval >= 3000 ? Math.min(rawInterval, 30000) : 6000;

      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          slide.setAttribute('aria-hidden', String(i !== current));
          // A merchant can add a link to a slide without leaving hidden links focusable.
          if ('inert' in slide) slide.inert = i !== current;
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
        // Load the following frame before its crossfade begins.
        slides[(current + 1) % slides.length].querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
      };
      const restart = () => {
        clearInterval(this._heroTimer);
        if (pauseButton) {
          pauseButton.hidden = !automatic || this._reduceMotion;
          pauseButton.setAttribute('aria-pressed', String(userPaused));
          const label = userPaused ? (pauseButton.dataset.labelPlay || 'Play slideshow') : (pauseButton.dataset.labelPause || 'Pause slideshow');
          pauseButton.setAttribute('aria-label', label);
          pauseButton.textContent = userPaused ? '▶' : 'Ⅱ';
        }
        if (!this._connected || !automatic || this._reduceMotion || userPaused || editorPaused || !visible || document.hidden || hero.contains(document.activeElement)) return;
        this._heroTimer = setInterval(() => show(current + 1), interval);
      };
      this._restartHero = restart;
      dots.forEach((dot, i) => this._on(dot, 'click', () => {
        const index = Number(dot.dataset.slide);
        show(Number.isInteger(index) && index >= 0 && index < slides.length ? index : i);
        restart();
      }));
      if (pauseButton) this._on(pauseButton, 'click', () => { userPaused = !userPaused; restart(); });
      this._on(hero, 'focusin', restart);
      this._on(hero, 'focusout', () => this._frame(restart));
      this._on(document, 'visibilitychange', restart);
      this._on(document, 'shopify:section:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = true;
        restart();
      });
      this._on(document, 'shopify:section:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._on(document, 'shopify:block:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target) || (event.detail?.blockId && slide.dataset.blockId === String(event.detail.blockId)));
        if (index < 0) return;
        editorPaused = true;
        show(index);
        restart();
      });
      this._on(document, 'shopify:block:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._observe(hero, entries => { visible = entries[0].isIntersecting; restart(); });
      show(current);
      restart();
    }

    _setupVideo() {
      const video = this.querySelector('.yuki-video video');
      const playButton = this.querySelector('.yuki-video-play');
      if (!video) return;
      const automatic = this.dataset.autoplay !== 'false';
      const generation = this._generation;
      let visible = !('IntersectionObserver' in window);
      let manualPlayback = false;
      let playRequest = 0;
      video.autoplay = false;
      video.removeAttribute('autoplay');
      const offerPlay = () => { if (playButton) playButton.hidden = false; };
      const play = async () => {
        const request = ++playRequest;
        try {
          await video.play();
          if (!this._connected || this._generation !== generation || request !== playRequest) return;
          if (playButton) playButton.hidden = true;
        } catch {
          if (this._connected && this._generation === generation && request === playRequest) offerPlay();
        }
      };
      const sync = () => {
        const autoAllowed = automatic && !this._reduceMotion;
        video.controls = !autoAllowed || manualPlayback;
        if (document.hidden || !visible) {
          ++playRequest;
          video.pause();
          return;
        }
        if (autoAllowed && !manualPlayback) {
          video.muted = true;
          void play();
        } else {
          if (!manualPlayback) video.pause();
          if (video.paused) offerPlay();
        }
      };
      this._syncVideo = sync;
      if (playButton) this._on(playButton, 'click', () => {
        manualPlayback = true;
        video.controls = true;
        void play();
      });
      this._on(video, 'play', () => {
        if (video.controls) manualPlayback = true;
        if (playButton) playButton.hidden = true;
      });
      this._on(video, 'pause', () => { if (video.controls && visible) offerPlay(); });
      this._on(video, 'ended', offerPlay);
      this._on(video, 'error', offerPlay);
      this._on(document, 'visibilitychange', sync);
      this._observe(video, entries => { visible = entries[0].isIntersecting; sync(); });
      sync();
    }

    _setupReveals() {
      const nodes = [...this.querySelectorAll('[data-reveal]')];
      if (!nodes.length) return;
      if (this._reduceMotion || !('IntersectionObserver' in window)) {
        this._revealAll();
        return;
      }
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (!this._connected || this._generation !== generation) return;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this._reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -100px 0px' });
      this._observers.push(observer);
      nodes.forEach(node => {
        if (node.classList.contains('is-revealed')) return;
        node.classList.add('is-pending');
        observer.observe(node);
      });
    }

    _reveal(node) {
      node.classList.add('is-revealed');
      node.classList.remove('is-pending');
      const counters = [...node.querySelectorAll('.yuki-counter, [data-counter-target]')];
      if (node.matches('.yuki-counter, [data-counter-target]')) counters.push(node);
      counters.forEach(counter => this._countUp(counter));
    }

    _revealAll() {
      this.querySelectorAll('[data-reveal]').forEach(node => this._reveal(node));
      if (this._reduceMotion) this._counterTargets.forEach((target, node) => { node.textContent = String(target); });
    }

    _countUp(number) {
      if (this._counted.has(number)) return;
      this._counted.add(number);
      const rawTarget = Number(number.dataset.counterTarget ?? number.textContent.trim());
      const target = Number.isFinite(rawTarget) ? Math.max(0, Math.min(100000, Math.round(rawTarget))) : 3;
      this._counterTargets.set(number, target);
      if (this._reduceMotion) { number.textContent = String(target); return; }
      const start = performance.now();
      const tick = now => {
        if (this._reduceMotion) { number.textContent = String(target); return; }
        const progress = Math.min((now - start) / 2000, 1);
        number.textContent = String(Math.floor(target * (1 - Math.pow(1 - progress, 3)) + .000001));
        if (progress < 1) this._frame(tick);
        else number.textContent = String(target);
      };
      this._frame(tick);
    }
  }

  customElements.define('yuki-showcase', YukiShowcase);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["yuki-06-outro"] && !Shopify.designMode) return;
  try {
    
/* No theme globals, commerce handlers or third-party dependencies. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('yuki-showcase')) return;

  class YukiShowcase extends HTMLElement {
    connectedCallback() {
      if (this._connected) return;
      this._connected = true;
      this._generation = (this._generation || 0) + 1;
      this._cleanups = [];
      this._observers = [];
      this._frames = new Set();
      this._counted = new WeakSet();
      this._counterTargets = new Map();
      this._motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this._reduceMotion = this._motionQuery.matches;
      this._on(this._motionQuery, 'change', () => {
        this._reduceMotion = this._motionQuery.matches;
        if (this._reduceMotion) this._revealAll();
        if (this._restartHero) this._restartHero();
        if (this._syncVideo) this._syncVideo();
      });
      this._setupReveals();
      this._setupHero();
      this._setupVideo();
      this._on(document, 'shopify:section:select', event => {
        if (this._ownsEditorEvent(event)) this._revealAll();
      });
    }

    disconnectedCallback() {
      this._connected = false;
      this._generation = (this._generation || 0) + 1;
      this._cleanups?.forEach(cleanup => cleanup());
      this._observers?.forEach(observer => observer.disconnect());
      this._frames?.forEach(frame => cancelAnimationFrame(frame));
      clearInterval(this._heroTimer);
      this._counterTargets?.forEach((target, node) => { node.textContent = String(target); });
      this.querySelectorAll('[data-reveal].is-pending').forEach(node => node.classList.remove('is-pending'));
      this.querySelectorAll('video').forEach(video => video.pause());
      this._restartHero = null;
      this._syncVideo = null;
    }

    _on(target, name, handler) {
      if (target.addEventListener) {
        target.addEventListener(name, handler);
        this._cleanups.push(() => target.removeEventListener(name, handler));
      } else if (name === 'change' && target.addListener) {
        target.addListener(handler);
        this._cleanups.push(() => target.removeListener(handler));
      }
    }

    _frame(callback) {
      const id = requestAnimationFrame(time => {
        this._frames.delete(id);
        if (this._connected) callback(time);
      });
      this._frames.add(id);
    }

    _observe(target, callback, options) {
      if (!('IntersectionObserver' in window)) return null;
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (this._connected && this._generation === generation) callback(entries);
      }, options);
      this._observers.push(observer);
      observer.observe(target);
      return observer;
    }

    _ownsEditorEvent(event) {
      const target = event.target;
      if (target instanceof Element && (target === this || this.contains(target) || target.contains(this))) return true;
      return Boolean(event.detail?.sectionId && this.id === `Yuki-${event.detail.sectionId}`);
    }

    _setupHero() {
      const hero = this.querySelector('.yuki-hero');
      if (!hero) return;
      const slides = [...hero.querySelectorAll('.yuki-hero-slide')];
      const dots = [...hero.querySelectorAll('.yuki-hero-dot')];
      const pauseButton = hero.querySelector('.yuki-hero-pause');
      if (!slides.length) return;
      let current = Math.max(0, slides.findIndex(slide => slide.classList.contains('is-active')));
      let visible = true;
      let userPaused = false;
      let editorPaused = false;
      const automatic = this.dataset.autoplay !== 'false' && slides.length > 1;
      const rawInterval = Number(this.dataset.interval);
      const interval = Number.isFinite(rawInterval) && rawInterval >= 3000 ? Math.min(rawInterval, 30000) : 6000;

      const show = index => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.classList.toggle('is-active', i === current);
          slide.setAttribute('aria-hidden', String(i !== current));
          // A merchant can add a link to a slide without leaving hidden links focusable.
          if ('inert' in slide) slide.inert = i !== current;
        });
        dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === current)));
        // Load the following frame before its crossfade begins.
        slides[(current + 1) % slides.length].querySelectorAll('img[loading="lazy"]').forEach(image => { image.loading = 'eager'; });
      };
      const restart = () => {
        clearInterval(this._heroTimer);
        if (pauseButton) {
          pauseButton.hidden = !automatic || this._reduceMotion;
          pauseButton.setAttribute('aria-pressed', String(userPaused));
          const label = userPaused ? (pauseButton.dataset.labelPlay || 'Play slideshow') : (pauseButton.dataset.labelPause || 'Pause slideshow');
          pauseButton.setAttribute('aria-label', label);
          pauseButton.textContent = userPaused ? '▶' : 'Ⅱ';
        }
        if (!this._connected || !automatic || this._reduceMotion || userPaused || editorPaused || !visible || document.hidden || hero.contains(document.activeElement)) return;
        this._heroTimer = setInterval(() => show(current + 1), interval);
      };
      this._restartHero = restart;
      dots.forEach((dot, i) => this._on(dot, 'click', () => {
        const index = Number(dot.dataset.slide);
        show(Number.isInteger(index) && index >= 0 && index < slides.length ? index : i);
        restart();
      }));
      if (pauseButton) this._on(pauseButton, 'click', () => { userPaused = !userPaused; restart(); });
      this._on(hero, 'focusin', restart);
      this._on(hero, 'focusout', () => this._frame(restart));
      this._on(document, 'visibilitychange', restart);
      this._on(document, 'shopify:section:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = true;
        restart();
      });
      this._on(document, 'shopify:section:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._on(document, 'shopify:block:select', event => {
        if (!this._ownsEditorEvent(event)) return;
        const index = slides.findIndex(slide => slide === event.target || slide.contains(event.target) || (event.detail?.blockId && slide.dataset.blockId === String(event.detail.blockId)));
        if (index < 0) return;
        editorPaused = true;
        show(index);
        restart();
      });
      this._on(document, 'shopify:block:deselect', event => {
        if (!this._ownsEditorEvent(event)) return;
        editorPaused = false;
        restart();
      });
      this._observe(hero, entries => { visible = entries[0].isIntersecting; restart(); });
      show(current);
      restart();
    }

    _setupVideo() {
      const video = this.querySelector('.yuki-video video');
      const playButton = this.querySelector('.yuki-video-play');
      if (!video) return;
      const automatic = this.dataset.autoplay !== 'false';
      const generation = this._generation;
      let visible = !('IntersectionObserver' in window);
      let manualPlayback = false;
      let playRequest = 0;
      video.autoplay = false;
      video.removeAttribute('autoplay');
      const offerPlay = () => { if (playButton) playButton.hidden = false; };
      const play = async () => {
        const request = ++playRequest;
        try {
          await video.play();
          if (!this._connected || this._generation !== generation || request !== playRequest) return;
          if (playButton) playButton.hidden = true;
        } catch {
          if (this._connected && this._generation === generation && request === playRequest) offerPlay();
        }
      };
      const sync = () => {
        const autoAllowed = automatic && !this._reduceMotion;
        video.controls = !autoAllowed || manualPlayback;
        if (document.hidden || !visible) {
          ++playRequest;
          video.pause();
          return;
        }
        if (autoAllowed && !manualPlayback) {
          video.muted = true;
          void play();
        } else {
          if (!manualPlayback) video.pause();
          if (video.paused) offerPlay();
        }
      };
      this._syncVideo = sync;
      if (playButton) this._on(playButton, 'click', () => {
        manualPlayback = true;
        video.controls = true;
        void play();
      });
      this._on(video, 'play', () => {
        if (video.controls) manualPlayback = true;
        if (playButton) playButton.hidden = true;
      });
      this._on(video, 'pause', () => { if (video.controls && visible) offerPlay(); });
      this._on(video, 'ended', offerPlay);
      this._on(video, 'error', offerPlay);
      this._on(document, 'visibilitychange', sync);
      this._observe(video, entries => { visible = entries[0].isIntersecting; sync(); });
      sync();
    }

    _setupReveals() {
      const nodes = [...this.querySelectorAll('[data-reveal]')];
      if (!nodes.length) return;
      if (this._reduceMotion || !('IntersectionObserver' in window)) {
        this._revealAll();
        return;
      }
      const generation = this._generation;
      const observer = new IntersectionObserver(entries => {
        if (!this._connected || this._generation !== generation) return;
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          this._reveal(entry.target);
          observer.unobserve(entry.target);
        });
      }, { rootMargin: '0px 0px -100px 0px' });
      this._observers.push(observer);
      nodes.forEach(node => {
        if (node.classList.contains('is-revealed')) return;
        node.classList.add('is-pending');
        observer.observe(node);
      });
    }

    _reveal(node) {
      node.classList.add('is-revealed');
      node.classList.remove('is-pending');
      const counters = [...node.querySelectorAll('.yuki-counter, [data-counter-target]')];
      if (node.matches('.yuki-counter, [data-counter-target]')) counters.push(node);
      counters.forEach(counter => this._countUp(counter));
    }

    _revealAll() {
      this.querySelectorAll('[data-reveal]').forEach(node => this._reveal(node));
      if (this._reduceMotion) this._counterTargets.forEach((target, node) => { node.textContent = String(target); });
    }

    _countUp(number) {
      if (this._counted.has(number)) return;
      this._counted.add(number);
      const rawTarget = Number(number.dataset.counterTarget ?? number.textContent.trim());
      const target = Number.isFinite(rawTarget) ? Math.max(0, Math.min(100000, Math.round(rawTarget))) : 3;
      this._counterTargets.set(number, target);
      if (this._reduceMotion) { number.textContent = String(target); return; }
      const start = performance.now();
      const tick = now => {
        if (this._reduceMotion) { number.textContent = String(target); return; }
        const progress = Math.min((now - start) / 2000, 1);
        number.textContent = String(Math.floor(target * (1 - Math.pow(1 - progress, 3)) + .000001));
        if (progress < 1) this._frame(tick);
        else number.textContent = String(target);
      };
      this._frame(tick);
    }
  }

  customElements.define('yuki-showcase', YukiShowcase);
})();

  } catch(e) { console.error(e); }
})();
})();
